import React, { useState, useEffect } from "react";
import { Form, FormGroup, Row, Col, ListGroup, ListGroupItem, Spinner, Button } from "reactstrap";
import PropTypes from "prop-types";
import style from "../../Grid.module.scss";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalLegalAddress from "../../Modal/ModalLegalAddress";
import { AccountMode, showToast, LegalAddresses } from "../../../../utils/Helper";
import CrossReferenceSearch from "../../../Modal/CrossReferenceSearch/CrossReferenceSearch";
import ModalError from "../../Modal/ModalError";

function generateEmptyLegalAddress() {
  return {
    LegalAddressCityId: 0,
    LegalAddressCityName: "",
    LegalAddressCountryId: 0,
    LegalAddressCountryIso: "",
    LegalAddressCountryName: "",
    LegalAddressExtraInformation1: "",
    LegalAddressExtraInformation2: "",
    LegalAddressId: 0,
    LegalAddressNumber: "",
    LegalAddressStateId: 0,
    LegalAddressStateName: "",
    LegalAddressStreet: "",
    LegalAddressType: LegalAddresses.Personal,
    LegalAddressZipCode: 0,
  };
}

const LegalAddressTab = ({
  services,
  document,
  legalAddress,
  onboarding,
  person,
  setPersonData,
  refresh,
  userSession,
}) => {
  const [modalLegalAddress, setModalLegalAddress] = useState({
    open: false,
    loading: true,
    initial: generateEmptyLegalAddress(),
    error: undefined,
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
  });

    const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  const toggleModalError = (e, message) => {
    const errorMessage = typeof e === "string" ? e : message;
    console.log('Toggling ModalError', { errorMessage, currentOpen: modalError.open });
    setModalError({
      open: !modalError.open,
      message: errorMessage || "",
    });
  };

  const SaveNewLegalAddress = (newLegalAddress) => {
    if (newLegalAddress.LegalAddressType === "") newLegalAddress.LegalAddressType = LegalAddresses.Personal;
    const body = {
      person: {
        PersonId: person.PersonId,
        LegalAddress: [newLegalAddress],
      },
    };
    setModalLegalAddress((m) => ({
      ...m,
      open: true,
      loading: true,
    }));

    if (onboarding) {
      let docs = legalAddress;
      let id = Number(docs.length) + 2;
      if (newLegalAddress.LegalAddressId > 0) {
        id = newLegalAddress.LegalAddressId;
        docs.forEach((p, i) => {
          if (p.LegalAddressId == newLegalAddress.LegalAddressId) {
            docs.splice(i, 1);
          }
        });
      }
      if (newLegalAddress.LegalAddressZipCode === "") newLegalAddress.LegalAddressZipCode = 0;

      const nAddress = {
        ...newLegalAddress,
        LegalAddressId: id,
      };

      docs.push(nAddress);
      const postPerson = {
        ...person,
        LegalAddress: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalLegalAddress({
            ...modalLegalAddress,
            open: false,
            callback: undefined,
            loading: false,
            messageShow: true,
            message: "",
          });
          refresh();
        } else {
          alert("Server Error");
        }
      });
    } else {
      const updatedBody = {
        ...body, 
        person: {
          ...body.person, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
      };
      services.fetchUpdatePersonLegalAddress(updatedBody, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const { result } = response;
            const newPerson = { ...person };
            let found = false;
            let index = 0;
            newPerson.LegalAddress = legalAddress.map((d, i) => {
              if (parseInt(d.LegalAddressId, 10) == parseInt(newLegalAddress.LegalAddressId, 10)) {
                index = i;
                found = true;
                setModalLegalAddress({
                  ...modalLegalAddress,
                  open: false,
                  callback: undefined,
                  loading: false,
                });
                return {
                  ...newLegalAddress,
                };
              }
              return {
                ...d,
              };
            });
            if (!found) {
              newLegalAddress.LegalAddressId = response.Id;
              legalAddress.push(newLegalAddress);
              newPerson.LegalAddress = legalAddress;
            } else {
              legalAddress[index] = newLegalAddress;
              newPerson.LegalAddress = legalAddress;
            }

            setPersonData({
              ...newPerson,
            });
            setModalLegalAddress((m) => ({
              open: false,
              loading: false,
              initial: generateEmptyLegalAddress(),
              error: undefined,
            }));
            refresh();
          
        } else {
          const errorMsg = response && response.result ? response.result.Description : "Server Error";
          toggleModalError(
            {},
            response && response.result
              ? `Error saving Person: ${response.result.Description}`
              : "Server Error"
          );
        }
      });
    }
  };

  const toggleModalConfirm = (d) =>
    setModalConfirm((mod) => {
      const newM = {
        ...mod,
        open: !mod.open,
      };
      if (d) {
        newM.title = "Are you sure you want to remove the selected Legal Address?";
        newM.callback = () => handleDeleteFile(d);
      }
      return newM;
    });

  const handleDeleteFile = (newLegalAddress) => {
    setModalConfirm((mod) => ({
      ...mod,
      saving: true,
    }));
    const body = {
      person: {
        PersonId: person.PersonId,
        LegalAddress: [newLegalAddress],
      },
      delete: true,
    };
    if (onboarding) {
      let docs = person.LegalAddress;
      if (newLegalAddress.LegalAddressId > 0) {
        docs.forEach((p, i) => {
          if (p.LegalAddressId == newLegalAddress.LegalAddressId) {
            docs.splice(i, 1);
          }
        });
      }
      const postPerson = {
        ...person,
        LegalAddress: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          setModalLegalAddress({
            ...modalLegalAddress,
            loading: false,
            messageShow: false,
            initial: undefined,
          });
        } else {
          alert("Server Error");
        }
      });
    } else {
      const updatedBody = {
        ...body, 
        person: {
          ...body.person, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
      };
      services.fetchUpdatePersonLegalAddress(updatedBody, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newPerson = { ...person };
          newPerson.LegalAddress.forEach((p, i) => {
            if (p.LegalAddressId == newLegalAddress.LegalAddressId) {
              newPerson.LegalAddress.splice(i, 1);
            }
          });
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          setPersonData({
            ...newPerson,
          });
        } else {
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            saving: false,
          });
          legalAddress.forEach((p, i) => {
            if (p.LegalAddressId == newLegalAddress.LegalAddressId) {
              const newPerson = { ...person };
              newPerson.LegalAddress.forEach((p, i) => {
                if (p.LegalAddressId == newLegalAddress.LegalAddressId) {
                  newPerson.LegalAddress.splice(i, 1);
                }
              });
            }
          });
        }
      });
    }
  };

  const toggleModalNewLegalAdress = (initial) =>
    setModalLegalAddress((m) => ({
      open: !m.open,
      loading: false,
      initial: initial,
    }));

  if (!legalAddress) {
    return <Spinner />;
  }

  const onEdit = (d) => {
    setModalLegalAddress((m) => ({
      ...m,
      open: true,
      loading: false,
      initial: d,
    }));
  };

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {legalAddress.map((d) => (
              <ListGroupItem key={d.LegalAddressId}>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Country: </Col>
                  <Col>{d.LegalAddressCountryName}</Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div style={{ cursor: "pointer", float: "right" }} onClick={() => onEdit(d)}>
                      <i className="fa fa-edit" />
                    </div>}
                  </Col>
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>State: </Col>
                  <Col>{d.LegalAddressStateName}</Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div style={{ cursor: "pointer", float: "right" }} onClick={() => toggleModalConfirm(d)}>
                      <i className="fa fa-trash" />
                    </div>}
                  </Col>
                </Row>

                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>City: </Col>
                  <Col> {d.LegalAddressCityName}</Col>
                  <Col />
                </Row>

                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Street: </Col>
                  <Col>{d.LegalAddressStreet}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Number: </Col>
                  <Col>{d.LegalAddressNumber}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Zip Code: </Col>
                  <Col>{d.LegalAddressZipCode}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Type:</Col>
                  <Col>{d.LegalAddressType ? d.LegalAddressType : "-"}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>Neighbourhood: </Col>
                  <Col>{d.LegalAddressExtraInformation1 ? d.LegalAddressExtraInformation1 : "-"}</Col>
                  <Col />
                </Row>
                <Row style={{ fontSize: "15px", fontWeight: 500 }}>
                  <Col>References: </Col>
                  <Col>{d.LegalAddressExtraInformation2 ? d.LegalAddressExtraInformation2 : "-"}</Col>
                  <Col />
                </Row>
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      <ModalError 
        open={modalError.open} 
        message={modalError.message} 
        onToggle={() => toggleModalError()} 
      />
      <ModalConfirm {...modalConfirm} toggle={toggleModalConfirm} />
      <ModalLegalAddress
        {...modalLegalAddress}
        toggle={toggleModalNewLegalAdress}
        onSave={SaveNewLegalAddress}
        document={document}
        loading={false}
        services={services}
      />

      {userSession.IsReadOnly === false && <Button
        onClick={() => toggleModalNewLegalAdress(generateEmptyLegalAddress())}
        color="primary"
        style={{ marginRight: 10 }}
      >
        Add New Legal Address
      </Button>}
    </div>
  );
};

function RenderDropdownActions({ onEdit, onDelete, index }) {
  return (
    <UncontrolledDropdown>
      <DropdownToggle color="link" size="lg" className={style.dropdown}>
        <i className="icon-options-vertical icons d-block" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onEdit(index)}>
          <i className="fa fa-edit" />
          Edit
        </DropdownItem>
        <DropdownItem onClick={() => onDelete(index)}>
          <i className="fa fa-trash" />
          Delete
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

RenderDropdownActions.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default LegalAddressTab;
